import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { MARKETS } from "@/lib/apiClient";

const SiteContext = createContext(null);
const MARKET_KEY = "aiyaiyai_market";
const SAVED_KEY = "aiyaiyai_saved";

export function SiteProvider({ children }) {
  const [market, setMarketState] = useState(() => {
    const code = localStorage.getItem(MARKET_KEY);
    return MARKETS.find((m) => m.code === code) || MARKETS[0];
  });
  const [saved, setSaved] = useState(() => {
    try { return JSON.parse(localStorage.getItem(SAVED_KEY) || "[]"); } catch { return []; }
  });

  const setMarket = useCallback((m) => {
    setMarketState(m);
    localStorage.setItem(MARKET_KEY, m.code);
  }, []);

  useEffect(() => {
    localStorage.setItem(SAVED_KEY, JSON.stringify(saved));
  }, [saved]);

  const toggleSaved = useCallback((slug) => {
    setSaved((prev) => (prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug]));
  }, []);
  const isSaved = useCallback((slug) => saved.includes(slug), [saved]);

  return (
    <SiteContext.Provider value={{ market, setMarket, saved, toggleSaved, isSaved }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
